module.exports = __webpack_public_path__ + "static/media/cnx_logo.15ed6c66.png";